import React, { useState } from 'react';
import { Modal, Button, Image, Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/pro-regular-svg-icons';

const VideoThumbnail = ({ videoId, thumbnail, className, transform }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const videoUrl = `https://www.youtube.com/embed/${videoId}&autoplay=1&mute=1`;

  return (
    <Container className={className}>
      <Row className="justify-content-center mobile-margin">
        <Col md={8} className="position-relative video-thumbnail-container">
          <div className="video-thumbnail-aspect-ratio">
            <Image src={thumbnail} className={`video-thumbnail ${transform}`}fluid />
          </div>

          <Button
            className="video-play-button"
            onClick={handleShow}
            variant="light"
          >
            <FontAwesomeIcon icon={faPlayCircle} className="fa-play-circle" />

           
          </Button>
        </Col>
      </Row>

      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body className="modal-body-black">
          <iframe
            title="YouTube video"
            width="100%"
            height="400"
            src={videoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Modal.Body>
        <Modal.Footer className="modal-body-black">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default VideoThumbnail;
